module.exports = require('./helpers/bundle-url').getBundleURL('dMC83') + "logo.c51670a8.svg";